import type { CaseCategoryTone } from './caseCategory';
import type { Column, ConfidenceFields, Direction, GroupId } from './legalCasesType';
import styles from './LegalCases.module.scss';

export const STATUS = {
    PENDING: { value: 'Pending' },
    DISPOSED: { value: 'Disposed' },
    NOT_AVAILABLE: { value: 'Not Available' },
};

export const CONFIDENCE_MATCH_THRESHOLD = 70;

export const ROW_MOTION_MS = 220;

export const ROW_MOTION_MAX_ROWS = 25;

export function isHighConfidence(c: ConfidenceFields): boolean {
    if (c.confidenceLevel) return c.confidenceLevel === 'HIGH';
    if (typeof c.matchPercentage === 'number') return c.matchPercentage >= CONFIDENCE_MATCH_THRESHOLD;
    return true;
}

export function hasConfidenceSignal(cases: ConfidenceFields[]): boolean {
    return cases.some((c) => c.confidenceLevel != null || typeof c.matchPercentage === 'number');
}

export const HEADERS = {
    FILED_BY: 'filedBy',
    FILED_AGAINST: 'filedAgainst',
    CASE_CATEGORY: 'caseCategory',
    COURT: 'court',
    STATUS: 'status',
    CASE_NUM: 'caseNum',
    DATE: 'date',
};
const HEADER_LABELS = {
    [HEADERS.FILED_BY]: 'Filed By',
    [HEADERS.FILED_AGAINST]: 'Filed Against',
    [HEADERS.CASE_CATEGORY]: 'Case Type',
    [HEADERS.COURT]: 'Court',
    [HEADERS.STATUS]: 'Status',
    [HEADERS.CASE_NUM]: 'Case No.',
    [HEADERS.DATE]: 'Date',
};

const HEADER_LABELS_STAR = {
    [HEADERS.FILED_BY]: 'Filed By*',
    [HEADERS.FILED_AGAINST]: 'Filed Against*',
};

export const CASE_TYPE_TONE_CLASS: Record<CaseCategoryTone, string> = {
    civil: styles.CaseType_Civil,
    criminal: styles.CaseType_Criminal,
    neutral: styles.CaseType_Neutral,
};

export const GROUP_BADGE_CLASS: Record<GroupId, string> = {
    OPEN: styles.CaseGroupBadge_Open,
    DISPOSED: styles.CaseGroupBadge_Disposed,
    OTHER: styles.CaseGroupBadge_Other,
};

export const COMPANY_NAME_PATTERN =
    /\b(ltd|limited|pvt|private|llp|inc|corp|corporation|company|industries|enterprises|traders|electricals|technologies|solutions|bank|government|authority|department|commissioner|ministry|board|insurance|agencies|products|pharma|textiles|exports|imports|motors|steels|associates|m\/s)\b|\bn\.a\.|& co\b/i;

export function getColumns(direction: Direction): Column[] {
    const [primary, secondary] =
        direction === 'filed_against' ? [HEADERS.FILED_AGAINST, HEADERS.FILED_BY] : [HEADERS.FILED_BY, HEADERS.FILED_AGAINST];

    return [
        { key: HEADERS.CASE_NUM, label: HEADER_LABELS[HEADERS.CASE_NUM] },
        { key: primary, label: HEADER_LABELS_STAR[primary] },
        { key: secondary, label: HEADER_LABELS[secondary] },
        { key: HEADERS.CASE_CATEGORY, label: HEADER_LABELS[HEADERS.CASE_CATEGORY] },
        { key: HEADERS.COURT, label: HEADER_LABELS[HEADERS.COURT] },
        { key: HEADERS.DATE, label: HEADER_LABELS[HEADERS.DATE] },
    ];
}
